// Public (pre-auth) auth POSTs for the forgot/reset pages. These hit the LEGACY-shape auth
// endpoints ({data,error} where error is a string), not the apiFetch {data,error,warnings}
// envelope — so we use a raw fetch with the X-Tenant header + relative path, mirroring
// AuthContext/refresh.ts. No access token (the user isn't signed in).

const TENANT = (import.meta.env.VITE_TENANT as string | undefined) ?? 'flightstandards';

export interface AuthPostResult { status: number; data: unknown; error: string | null }

export async function postAuth(path: string, body: unknown): Promise<AuthPostResult> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'X-Tenant': TENANT },
      body: JSON.stringify(body),
    });
  } catch {
    return { status: 0, data: null, error: 'Could not reach the server. Please try again.' };
  }
  const json = (await res.json().catch(() => ({ data: null, error: 'Unexpected response.' }))) as { data?: unknown; error?: string | null };
  return { status: res.status, data: json.data ?? null, error: json.error ?? null };
}
